import React, { useState } from "react";
import Navbar from "./navbar";
import Choix from "./choix";
import Compteur from "./compteur";

import config from "../config";

const getHash = () => {
    const [
        ,
        ,
        hashChoix = "milliers",
        ,
        hashNombre = 0,
    ] = document.location.hash.match(
        /^(#(milliards|millions|milliers|unites|decimaux))?(=([0-9]*([\.,][0-9]{1,3})?))?/
    );
    const intervalle = config.byId[hashChoix];
    const nombre =
        hashNombre !== 0 ? hashNombre.toString().replace(",", ".") : 0;

    document.location.hash = `#${hashChoix}`;
    return {
        choix: hashChoix,
        nombre: nombre < intervalle.max ? nombre : 0,
    };
};
const initialCompteur = getHash();
export default ({ title }) => {
    const [compteur, setCompteur] = useState(initialCompteur);

    const updateCompteur = ({ type, payload }) => {
        switch (type) {
            case "CHANGE_CHOIX":
                setCompteur({
                    choix: payload,
                    nombre: 0,
                });
                document.location.hash = `#${payload}`;
                break;
            case "INCREMENT":
                const next = Math.round(
                    compteur.nombre * 1000 + Math.pow(10, payload + 3)
                );
                setCompteur({
                    ...compteur,
                    nombre:
                        next < config.byId[compteur.choix].max * 1000
                            ? next / 1000
                            : compteur.nombre,
                });
                break;
            case "DECREMENT":
                const prev = Math.round(
                    compteur.nombre * 1000 - Math.pow(10, payload + 3)
                );
                setCompteur({
                    ...compteur,
                    nombre: prev >= 0 ? prev / 1000 : compteur.nombre,
                });
                break;
            default:
                break;
        }
    };

    const handleUpdateChoix = ({ choix }) => {
        updateCompteur({ type: "CHANGE_CHOIX", payload: choix });
    };
    const handleUpdateNombre = ({ action, coef }) => {
        updateCompteur({ type: action, payload: coef });
    };

    return (
        <div className="container">
            <Navbar title={title} />
            <div className="row">
                <div className="row mb-3">
                    <Choix
                        choix={compteur.choix}
                        updateChoix={handleUpdateChoix}
                    />
                </div>
                <div className="row">
                    <Compteur
                        compteur={compteur}
                        updateNombre={handleUpdateNombre}
                    />
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/app.js